import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_JOBS_BY_CLASS_ID = gql`
  query GetViewedJobsByClassId($classId: Int!) {
    getViewedJobs(schoolClassID: $classId) {
      id
      name
      visits
      image {
        ...imageFields
      }
    }
  }
  ${ImageFragment}
`;
